import { Grid, Typography } from '@mui/material';
import React from 'react';

import {
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
} from 'react-admin';

import ColoredChipField from './ColoredChipField';

const TagArraySelectInput = ({ disabled }: { disabled: boolean }) => (
  <Grid container spacing={1}>
    <Grid size={12}>
      <Typography variant="label">Tag assignment</Typography>
    </Grid>
    <Grid size={12}>
      {disabled ? (
        <ReferenceArrayField
          perPage={100}
          source="tags"
          reference="tags"
          filter={{ active: true }}
        >
          <SingleFieldList empty="-">
            <ColoredChipField />
          </SingleFieldList>
        </ReferenceArrayField>
      ) : (
        <ReferenceArrayInput
          perPage={100}
          source="tags"
          reference="tags"
          filter={{ active: true }}
        >
          <SelectArrayInput disabled={disabled} label="Tag names" fullWidth />
        </ReferenceArrayInput>
      )}
    </Grid>
  </Grid>
);

export default TagArraySelectInput;
